/*
 * Cart drawer: view_cart instrumentation.
 * Spec: specs/sections/cart-drawer-compress-2026-09-10.md
 *
 * WHY A SEPARATE ASSET: assets/theme.js is minified and do-not-edit, theme.dev.js
 * is not loaded, and there is no build step (CLAUDE.md, Tooling). Every JS
 * behaviour change on this theme ships as a scoped asset instead — same pattern
 * as size-selector-redesign.js and pdp-variant-image-swap.js.
 *
 * WHAT IT DOES: emits view_cart when the drawer opens. The drawer does not emit
 * it at all today — view_cart fired 603 times against 11,419 add_to_cart in GA4
 * property 323606167 over 2026-08-13 to 2026-09-09 — so there is no baseline to
 * measure a cart change against.
 *
 * An earlier revision also relocated the highest-share wallet out of a
 * disclosure. That disclosure was removed after its own render was measured
 * pushing three wallet buttons 110px below the drawer's bottom edge, so the DOM
 * move went with it. Wallets now lay out as a row in CSS and need no JS.
 *
 * TWO STRUCTURAL FACTS THIS CODE IS BUILT AROUND
 * - The drawer lives inside <template data-cart-drawer-template> and nothing
 *   exists in the DOM until CartDrawer clones it on first open, so a one-shot
 *   query at DOMContentLoaded finds nothing.
 * - CartDrawer signals open state with a class on <body>, which is also how the
 *   theme's own CSS knows. Watching that class gives one event per open rather
 *   than one per cart re-render.
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'js-drawer-open-cart';

  /* gtag is a real function on this storefront and gtag/js is loaded, so an
     event here reaches every configured GA4 property directly. dataLayer is the
     fallback only; emitting to both would double-count, because GTM is what
     loads gtag in the first place. Verified on the live page 2026-09-10. */
  function emit(payload) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'view_cart', payload);
      return;
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'view_cart' }, payload));
    }
  }

  function sendViewCart() {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';

    fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;

        emit({
          currency: cart.currency,
          value: (cart.total_price || 0) / 100,
          items: (cart.items || []).map(function (line, index) {
            return {
              item_id: line.sku || String(line.variant_id),
              item_name: line.product_title,
              item_variant: line.variant_title || undefined,
              item_brand: line.vendor || undefined,
              price: (line.final_price || 0) / 100,
              quantity: line.quantity,
              index: index
            };
          })
        });
      })
      .catch(function () {
        /* Instrumentation must never break a checkout path. */
      });
  }

  function init() {
    var wasOpen = document.body.classList.contains(OPEN_CLASS);

    new MutationObserver(function () {
      var isOpen = document.body.classList.contains(OPEN_CLASS);
      if (isOpen && !wasOpen) sendViewCart();
      wasOpen = isOpen;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
